module.exports = __webpack_public_path__ + "img/4 grading.75074196.jpeg";